import React from "react";
import styles from "../style.module.css";
import DeleteModel from "../DeleteModel2";
import { Pagination } from "antd";
import {
  Spinner,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import ViewAdStats from "../ViewStats/ViewAdStats";
import WithdrawModel from "../WithdrawModel";
import ReasonModel from "../ReasonModel";

const Overview = ({ ads, total, page, setPage, loading }) => {
  function formatDate(inputDate) {
    const date = new Date(inputDate);

    // Get day with suffix
    function getDayWithSuffix(day) {
      if (day >= 11 && day <= 13) {
        return day + "th";
      }
      switch (day % 10) {
        case 1:
          return day + "st";
        case 2:
          return day + "nd";
        case 3:
          return day + "rd";
        default:
          return day + "th";
      }
    }

    // Define months as an array for formatting
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Format the date manually
    const formattedDate =
      getDayWithSuffix(date.getDate()) +
      " " +
      months[date.getMonth()] +
      ", " +
      date.getFullYear();

    return formattedDate;
  }

  function mapStatus(status, releaseDate) {
    const currentDate = new Date();
    switch (status) {
      case "Approved":
        return new Date(releaseDate) <= currentDate ? "Live" : "Approved";
      case "Requested":
        return "In Verification";
      case "Rejected":
        return "Rejected";
      case "Ended":
        return "Ended";
      default:
        return status;
    }
  }

  function getStatusStyle(status) {
    switch (status) {
      case "Live":
        return styles.liveStatus;
      case "Approved":
        return styles.approvedStatus;
      case "In Verification":
        return styles.inVerificationStatus;
      case "Rejected":
        return styles.rejectedStatus;
      case "Ended":
        return styles.endedStatus;
      default:
        return styles.defaultStatus;
    }
  }

  return (
    <div className={styles.tableDiv}>
      <TableContainer
        style={{ border: "1px solid #D9E1E7", borderRadius: "20px" }}
      >
        <Table variant="simple">
          <Thead>
            <Tr>
              <Th style={{ textTransform: "capitalize" }}>Partner Name</Th>
              <Th style={{ textTransform: "capitalize" }}>Ad Name</Th>
              <Th style={{ textTransform: "capitalize" }}>Ad Title</Th>
              <Th style={{ textTransform: "capitalize" }}>Ad body</Th>
              <Th style={{ textTransform: "capitalize" }}>Ad Type</Th>
              <Th style={{ textTransform: "capitalize" }}>Release on</Th>
              <Th style={{ textTransform: "capitalize" }}>Created on</Th>
              <Th style={{ textTransform: "capitalize" }}>Status</Th>
              <Th style={{ textTransform: "capitalize" }}>Action</Th>
            </Tr>
          </Thead>
          {loading ? (
          <span className={styles.spin}>
            <Spinner
              thickness="4px"
              speed="0.65s"
              emptyColor="gray.200"
              color="blue.500"
              size="lg"
            />
          </span>
        ) : (
          <Tbody>
            {ads.map((el, i) => (
              <Tr key={i}>
                <Td>{el.partnerId?.fullName}</Td>
                <Td>{el.name}</Td>
                <Td>{el.title}</Td>
                <Td>{el.body}</Td>
                <Td>{el.adType}</Td>
                <Td>{formatDate(el.releaseDate)}</Td>
                <Td>{formatDate(el.createdAt)}</Td>
                <Td>
                  <p
                    className={`${styles.blackBtn21} ${getStatusStyle(
                      mapStatus(el.status, el.releaseDate)
                    )}`}
                  >
                    {mapStatus(el.status, el.releaseDate)}
                  </p>
                </Td>
                <Td>
                <div className={styles.actionDiv}>
                {(() => {
                      const status = mapStatus(el.status, el.releaseDate);
                      switch (status) {
                        case "Approved":
                          return <DeleteModel />;
                        case "Live":
                          return "Stats available in the next 24 hours";
                        case "In Verification":
                          return <WithdrawModel />;
                        case "Rejected":
                          return <ReasonModel />;
                        default:
                          return null; // Handle other cases or add a default action
                      }
                    })()}
                  </div>
                </Td>
              </Tr>
            ))}
          </Tbody>
            )}
        </Table>
      </TableContainer>

      {total > 10 && (
        <div className={styles.pagination}>
          <Pagination
            defaultCurrent={1}
            total={total}
            onChange={(e) => setPage(e)}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

export default Overview;
